module.exports = __webpack_public_path__ + "static/media/galdisa_ventajas_bg.667e0eb3.jpg";